module.exports = __webpack_public_path__ + "img/3.05ea58b9.png";